import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react';
import { Modal, Form, Input, Row, Col, Select, message, Spin, DatePicker } from 'antd';
import PropTypes from 'prop-types';
import UpdateConnectionPopup from './UpdateConnectionPopup';
import DeleteConnectionPopup from './DeleteConnectionPopup';
import { setEditCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { AddUser } from '../style';
import { BasicFormWrapper } from '../../styled';
import { PriorityDealApi, FetchAllDeal } from '../../../Api/Services/DealApiService'
import { taskstatusApi, massUpdateTask, massDeleteTasks, tasktypeApi } from '../../../Api/Services/TaskapiService'
import { getTriggerFiledforEntity, getAllUsersData } from '../../../Api/Services/CommonApiService'
import { FetchAllAccount } from '../../../Api/Services/AccountApiService';
import { FetchAllLead } from '../../../Api/Services/LeadApiServices';
import { FetchAllContact } from '../../../Api/Services/ContactApiService';
import { getCasebuReportingUser, getFollowingCasebyUser } from '../../../Api/Services/CaseApiServices'
import { Button } from '../../../components/buttons/buttons'

const { Option } = Select;

const Popup = ({ updatePopup, setUpdatePopup, taskIDs, GetAll, popupType, pageType, setStates, AutomationMessage, successMessage }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const [users, setUsers] = useState([])
    const [taskStatus, setTaskStatus] = useState()
    const [errorData, setErrorData] = useState([])
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [allTaskType, setAllTaskType] = useState([])
    const [typeNames, setTypeNames] = useState()
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const [dealPriority, setDealPriority] = useState([])
    const [uiReady, setUiReady] = useState(false)
    const [editAttributes, setEditAttributes] = useState([])
    const [selectBoxes, setSelectBoxes] = useState([{ editedField: "taskOwner", editedValue: null }]);
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    function RequiredValidity(queryData) {
        for (let i = 0; i < queryData.length; i += 1) {
            const query = queryData[i];
            if (!query.editedField) {
                return { isValid: false, message: 'Incomplete field(s)' };
            }
            if (query.editedValue === undefined || query.editedValue === null ||
                (typeof query.editedValue === 'string' && query.editedValue.trim() === '')) {
                return { isValid: false, message: 'Incomplete field(s)' };
            }
        }
        return { isValid: true };
    }
    const handleClose = () => {
        setUpdatePopup(false);
        if (pageType === "Listing") {
            setStates({
                selectedRows: [],
                selectedRowKeys: [],
            })
        }
        if (popupType !== "Delete") {
            // setState({ selectedRowKeys: [] })
        }
    }
    const GetPriorityDealApi = async () => {
        try {
            const data = await PriorityDealApi()
            const options = data.map((option, i) => (
                <Option value={option.priorityName} key={i} >
                    {option.priorityName}
                </Option>));
            setDealPriority(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const HandleIsModalVisible = (value) => {
        setUpdatePopup(value)
        setIsModalVisible(value)
    }
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            setUsers(data)
        } catch (error) {
            message.error(error)
        }
    }
    const TaskStatusApi = async () => {
        try {
            const data = await taskstatusApi()
            const options = data.map((option) => (
                <Option value={option.taskStatusId} key={option.taskStatusName}>
                    {option.taskStatusName}
                </Option>));
            setTaskStatus(options)
        } catch (error) {
            message.error(error)
        }
    }
    async function TaskTypeApi() {
        try {
            const data = await tasktypeApi()
            const options = data.map((option) => (
                <Option value={option.taskTypeId} key={option.taskTypeName}>
                    {option.taskTypeName}
                </Option>))
            setAllTaskType(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function Triggerfields() {
        try {
            const response = await getTriggerFiledforEntity("Task")
            const removeFields = ["taskName"]; // "taskTypeId", "relatedToId",
            const filteredAttributes = response?.filter((item) => item.filedValue !== "description").filter(
                item => !removeFields.includes(item.filedValue)
            );
            setEditAttributes(filteredAttributes)
        } catch (error) {
            message.error(error)
        }
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            Triggerfields(),
            TaskTypeApi(),
            GetPriorityDealApi(),
            TaskStatusApi(),
            UserDetailsApi(),
        ])
        setUiReady(true)
    };
    useEffect(() => {
        if (updatePopup) {
            if (popupType === "Bulk Update") {
                fetchAll()
            }
            else {
                setUiReady(true)
            }
        }
    }, [updatePopup])
    const getRefreshtheTable = () => {
        setUpdatePopup(false);
        if (popupType === "Bulk Delete") {
            GetAll();
            setStates({
                selectedRows: [],
                selectedRowKeys: [],
            })
        } if (popupType === "Delete") {
            history.push('/Home/tasks')
        }
    }
    const onSubmit = async () => {

        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        const formData = {
            taskIds: taskIDs,
            // country,
            // state,
            // city,
        }
        if (popupType === "Bulk Update") {
            const validation = RequiredValidity(selectBoxes);
            if (!validation.isValid) {
                message.error(validation.message);
                loadingRef.current = false;
                setDelteClick(false)
                return;
            }
            const flatFields = selectBoxes.reduce((acc, item) => {
                const { editedField, editedValue, visible } = item;
                if (!editedField) return acc;
                // CASE 1: visible === "No" → always include field
                if (visible === "No") {
                    acc[editedField] = Array.isArray(editedValue)
                        ? editedValue.join(',')
                        : normalizeValue(editedValue);
                    return acc;
                }
                // CASE 2: include only non-null values
                if (editedValue != null) {
                    acc[editedField] = Array.isArray(editedValue)
                        ? editedValue.join(',')
                        : normalizeValue(editedValue);
                }
                return acc;
            }, {});
            Object.assign(formData, flatFields);
            try {
                const response = await massUpdateTask(formData)
                if (response.status === 200) {
                    const allUpdatedSuccessfully = response.data.every(item =>
                        item.message === "Task Has Updated Successfully"
                    );
                    if (allUpdatedSuccessfully) {
                        dispatch(setEditCall(false))
                        if (pageType === "Listing") {
                            setStates({
                                selectedRows: [],
                                selectedRowKeys: [],
                            })
                        }
                        message.success("Data updated for selected records")
                        GetAll()
                        setUpdatePopup(false);
                        loadingRef.current = false;
                        setDelteClick(false)
                        return;
                    }
                    loadingRef.current = false;
                    setDelteClick(false)
                    dispatch(setEditCall(false))
                    setErrorData(response.data);
                    setIsModalVisible1(true);
                }
            }
            catch (error) {
                loadingRef.current = false;
                setDelteClick(false)
                message.error(error)
            }
        }
    }
    async function onDelete() {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        const payload = {
            taskIds: taskIDs
        }
        try {
            const response = await massDeleteTasks(payload)
            if (response.status === 200) {
                if (popupType === "Delete") {
                    if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                        setErrorData(response.data);
                        setIsModalVisible(true);
                        dispatch(setEditCall(false))
                        loadingRef.current = false;
                        setDelteClick(false)
                    } else {
                        const isAutomation = response.data[0].entityMessage === AutomationMessage;
                        dispatch(setEditCall(false))
                        if (isAutomation) {
                            successMessage("Automation rule triggered", response.data[0].entityMessage);
                        } else {
                            message.success(
                                <span>
                                    Task <strong>{response?.data?.[0]?.entityName}</strong> has been deleted successfully
                                </span>
                            );
                        }
                        loadingRef.current = false;
                        setDelteClick(false)
                        history.push('/Home/tasks')
                        setUpdatePopup(false);
                    }
                } else {
                    const allUpdatedSuccessfully = response.data.every(item =>
                        item.entityMessage === "Task Has Deleted Successfully"
                    );
                    if (allUpdatedSuccessfully) {
                        dispatch(setEditCall(false))
                        message.success(`${taskIDs.length} record${taskIDs.length > 1 ? "s" : ""} deleted successfully`);
                        GetAll();
                        setStates({
                            selectedRows: [],
                            selectedRowKeys: [],
                        })
                        setUpdatePopup(false);
                        loadingRef.current = false;
                        setDelteClick(false)
                        return;
                    }
                    loadingRef.current = false;
                    setDelteClick(false)
                    dispatch(setEditCall(false))
                    setErrorData(response.data);
                    setIsModalVisible(true);
                }
            }
        }
        catch (error) {
            loadingRef.current = false;
            setDelteClick(false)
            message.error(error)
        }
    }
    const handleTypeChange = async (value) => {
        setTypeNames([])
        try {
            if (value === 1) {
                const allAccounts = await FetchAllAccount();
                const accountMap = new Map(allAccounts.map(item => [item.account_id, item]));
                const fullAccountList = Array.from(accountMap.values());
                const filterData = fullAccountList.filter((item) => item.account_type_name === "Customer").map((option, i) => (
                    <Option value={option.account_id} key={i} label={(
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.account_name} (${option.account_number})`}>
                            {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                < img src={option.account_profile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag AccountIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                    {option.account_name.slice(0, 1).toUpperCase()}
                                </span>
                            }
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                        </div>)}>
                        <div className='UserList-dropdown' title={`${option.account_name} (${option.account_number})`}>
                            <div>
                                {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                    < img src={option.account_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                    :
                                    <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                        {option.account_name.slice(0, 1).toUpperCase()}
                                    </span>
                                }</div>
                            <div>
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                                <p style={{ margin: 0 }}>{option?.account_number}</p>
                            </div>
                        </div>
                    </Option>));
                setTypeNames(filterData)
            }
            else if (value === 2) {
                const allAccounts = await FetchAllLead()
                const accountMap = new Map(allAccounts?.items.map(item => [item.leads_id, item]));
                const fullAccountList = Array.from(accountMap.values());
                const options = fullAccountList.map((option, i) => (
                    <Option value={option.leads_id} key={i} label={(
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.first_name} ${option.last_name} (${option.primary_email})`}>
                            {option.lead_profile !== null && option.lead_profile !== undefined && option.lead_profile !== "" ?
                                < img src={option.lead_profile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag LeadIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                    {option.first_name.slice(0, 1).toUpperCase()}
                                </span>
                            }
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                        </div>)} >
                        <div className='UserList-dropdown' title={`${option.first_name} ${option.last_name} (${option.primary_email})`}>
                            <div>
                                {option.lead_profile !== null && option.lead_profile !== undefined && option.lead_profile !== "" ?
                                    < img src={option.lead_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                    :
                                    <span className='details_span_Tag LeadIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                        {option.first_name.slice(0, 1).toUpperCase()}
                                    </span>
                                }</div>
                            <div>
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                                <p style={{ margin: 0 }}>{option?.primary_email}</p>
                            </div>
                        </div>
                    </Option>));
                setTypeNames(options)
            }
            else if (value === 3) {
                const allAccounts = await FetchAllContact()
                const accountMap = new Map(allAccounts?.items.map(item => [item.contacts_id, item]));
                const fullAccountList = Array.from(accountMap.values());
                const options = fullAccountList.map((option, i) => (
                    <Option value={option.contacts_id} key={i} label={(
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.first_name} ${option.last_name} (${option.email})`}>
                            {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                < img src={option.contact_profile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag ContactIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                    {option.first_name.slice(0, 1).toUpperCase()}
                                </span>
                            }
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                        </div>)} >
                        <div className='UserList-dropdown' title={`${option.first_name} ${option.last_name} (${option.email})`}>
                            <div>
                                {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                    < img src={option.contact_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                    :
                                    <span className='details_span_Tag ContactIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                        {option.first_name.slice(0, 1).toUpperCase()}
                                    </span>
                                }</div>
                            <div>
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                                <p style={{ margin: 0 }}>{option?.email}</p>
                            </div>
                        </div>
                    </Option>));
                setTypeNames(options)
            }
            else if (value === 4) {
                const allAccounts = await FetchAllDeal()
                const accountMap = new Map(allAccounts.map(item => [item.deals_id, item]));
                const fullAccountList = Array.from(accountMap.values());
                const options = fullAccountList.map((option, i) => (
                    <Option value={option.deals_id} key={i} label={(
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.deal_name} (${option.pipelineStage})`}>
                            {option.deal_profile !== null && option.deal_profile !== undefined && option.deal_profile !== "" ?
                                < img src={option.deal_profile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag DealIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                    {option.deal_name.slice(0, 1).toUpperCase()}
                                </span>
                            }
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.deal_name}</p>
                        </div>)}>
                        <div className='UserList-dropdown' title={`${option.deal_name} (${option.pipelineStage})`}>
                            <div>
                                {option.deal_profile !== null && option.deal_profile !== undefined && option.deal_profile !== "" ?
                                    < img src={option.deal_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                    :
                                    <span className='details_span_Tag DealIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                        {option.deal_name.slice(0, 1).toUpperCase()}
                                    </span>
                                }</div>
                            <div>
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.deal_name}</p>
                                <p style={{ margin: 0 }}>{option?.pipelineStage}</p>
                            </div>
                        </div>
                    </Option>));
                setTypeNames(options)
            }
            else if (value === 5) {
                const dataRaw = await getCasebuReportingUser()
                const responseRaw = await getFollowingCasebyUser()
                const data = dataRaw.map(item => ({ ...item, CaseLinkType: "CASE" }));
                const response = responseRaw.map(item => ({ ...item, CaseLinkType: "FCASE" }));
                const mergedCases = [
                    ...data,
                    ...response.filter(fc => !data.some(rc => rc.caseId === fc.caseId))
                ];
                const accountMap = new Map(mergedCases.map(item => [item.caseId, item]));
                const fullAccountList = Array.from(accountMap.values());
                const options = fullAccountList.map((option, i) => (
                    <Option value={option.caseId} key={i} label={(
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.caseSubject} (${option.caseNumber})`}>
                            <span className='details_span_Tag' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                {option.caseSubject.slice(0, 1).toUpperCase()}
                            </span>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.caseSubject}</p>
                        </div>)}>
                        <div className='UserList-dropdown' title={`${option.caseSubject} (${option.caseNumber})`}>
                            <div>
                                <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.caseSubject.slice(0, 1).toUpperCase()}
                                </span>
                            </div>
                            <div>
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.caseSubject}</p>
                                <p style={{ margin: 0 }}>{option?.caseNumber}</p>
                            </div>
                        </div>
                    </Option>));
                setTypeNames(options)
            }
            else {
                setTypeNames([])
            }
        } catch (error) {
            setTypeNames([])
            message.error(error)
        }
    }
    const handleViewChange = async (index, fieldName, value, key, currecnyData) => {
        let updatedFormData = [...selectBoxes];
        if (fieldName === "editedField") {
            const oldData = updatedFormData[index].editedField;
            if (oldData === "taskTypeId") {
                updatedFormData = updatedFormData?.filter((item, idx) => {
                    if (idx === 0) return true;
                    return !["relatedToId"].includes(item.editedField);
                });
            }
            updatedFormData[index] = {
                ...updatedFormData[index],
                editedField: normalizeValue(value),
                editedValue: normalizeValue(value) === "relatedToId" ? [] : null,
                Key: key,
                Currency: currecnyData
            };
            if (normalizeValue(value) === "taskTypeId" || normalizeValue(value) === "relatedToId") {
                if (normalizeValue(value) === "taskTypeId") {
                    const hasContact = updatedFormData.some(item => item.editedField === "relatedToId");
                    if (!hasContact) {
                        const contactInsert = {
                            editedField: "relatedToId",
                            editedValue: [],
                            Key: null,
                            Currency: null
                        };
                        const accountIndex = updatedFormData.findIndex(item => item.editedField === "taskTypeId");
                        const insertAt = accountIndex >= 0 ? accountIndex + 1 : index;
                        updatedFormData.splice(insertAt, 0, contactInsert);
                        index = insertAt + 1;
                    }
                    setTypeNames([])
                }
                if (normalizeValue(value) === "relatedToId") {
                    const hasCountry = updatedFormData.some(item => item.editedField === "taskTypeId");
                    const inserts = [];
                    if (!hasCountry) {
                        inserts.push({
                            editedField: "taskTypeId",
                            editedValue: null,
                            Key: null,
                            Currency: null
                        });
                    }
                    if (inserts.length > 0) {
                        updatedFormData.splice(index, 0, ...inserts);
                        index += inserts.length;
                    }
                }
            }
            else {
                updatedFormData = updatedFormData?.filter(
                    item => !["taskTypeId", "relatedToId"].includes(item.editedField)
                );
            }
        }
        else {
            const editedFieldType = updatedFormData[index]?.editedField;
            updatedFormData[index] = {
                ...updatedFormData[index],
                [fieldName]: value,
                Key: key
            };
            if (editedFieldType === "taskTypeId") {
                try {
                    await handleTypeChange(normalizeValue(value))
                    const existingIndex = updatedFormData.find(
                        item => item.editedField === "relatedToId"
                    );
                    if (existingIndex) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "relatedToId") {
                                return {
                                    ...item,
                                    editedValue: []
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "relatedToId",
                            editedValue: [],
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }

                }
                catch (error) {
                    updatedFormData = updatedFormData.map(item => {
                        if (item.editedField === "relatedToId") {
                            return {
                                ...item,
                                editedValue: []
                            };
                        }
                        return item;
                    });
                    setTypeNames([])
                    message.error(error)
                }
            }
        }
        setSelectBoxes(updatedFormData);
    };
    const getAvailableOptions = (currentIndex) => {
        const selectedValues = selectBoxes.map(box => box.editedField).filter(value => value !== undefined);
        return editAttributes.filter(option => !selectedValues.includes(option.filedValue) || selectBoxes[currentIndex].editedField === option.filedValue);
    };
    function getFieldTypeByValue(fieldValue) {
        const field = editAttributes.find(item => item.filedValue === fieldValue);
        return field ? field.FieldType : null;
    }
    return (
        <>
            <Modal
                title={popupType}
                open={updatePopup}
                onCancel={handleClose}
                // centered
                maskClosable={false}
                footer={uiReady ? [
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 8, whiteSpace: 'nowrap' }}>
                        {popupType === "Bulk Update" &&
                            <>
                                <Button onClick={handleClose} className="gray-button" size="small">
                                    <FeatherIcon icon="x" />Cancel
                                </Button>
                                <Button className='btn-add_new button_colors' size="small" onClick={onSubmit} loading={deleteClick} disabled={deleteClick}>
                                    {!deleteClick && <FeatherIcon icon="save" />}Update
                                </Button>
                            </>
                        }
                        {popupType.includes("Delete") &&
                            <>
                                <Button htmlType="submit" className="gray-button" size="small" onClick={handleClose}>
                                    <FeatherIcon icon="x" /> Cancel
                                </Button>
                                <Button htmlType="submit" onClick={onDelete} size="small" className='red-button' loading={deleteClick} disabled={deleteClick}>
                                    {!deleteClick && <FeatherIcon icon="trash-2" />}{popupType}
                                </Button>
                            </>}
                    </div>
                ] : false}
            // width={600}
            >
                {uiReady ? <>  {popupType === "Bulk Update" &&
                    (editAttributes.length > 0 ? <AddUser>
                        <div className="user-info-form">
                            <BasicFormWrapper>
                                <Form style={{ width: '100%' }} form={form} name="LeadMassUpdate" >
                                    {selectBoxes.map((selectbox, index) => {
                                        const filedType = getFieldTypeByValue(selectbox.editedField)
                                        return (
                                            <Row gutter={30} style={{ marginBottom: 20, marginTop: 20, padding: "0px 20px" }}>
                                                <Col span={10}>
                                                    <Form.Item >
                                                        <Select style={{ width: '100%' }}
                                                            placeholder="Select Field"
                                                            showSearch
                                                            optionFilterProp="children"
                                                            filterOption={(input, option) =>
                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                            }
                                                            value={selectbox.editedField}
                                                            onChange={(record, option) => {
                                                                const Key = option.FieldType
                                                                const currecnyData = option.FieldData
                                                                handleViewChange(index, 'editedField', record, Key, currecnyData);
                                                            }}
                                                            disabled={index !== 0}
                                                        >
                                                            {getAvailableOptions(index).map((option, idx) => (
                                                                <Option value={option.filedValue} key={idx} FieldType={option.FieldType} FieldData={option.currencyType}>
                                                                    {option.fieldLable}
                                                                </Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={14}>
                                                    <Form.Item key={index}>
                                                        {filedType === 'Drop Down' ? (
                                                            <Select placeholder="Select Value"
                                                                showSearch
                                                                style={{ width: "100%" }}
                                                                optionFilterProp="children"
                                                                mode={(selectbox.editedField === "relatedToId") && 'multiple'}
                                                                {...(selectbox.editedField === "taskOwner" || selectbox.editedField === "assignTo" || selectbox.editedField === "relatedToId"
                                                                    ? { optionLabelProp: "label" } : {})}
                                                                filterOption={(input, option) =>
                                                                    (selectbox.editedField === "taskOwner" || selectbox.editedField === "assignTo" || selectbox.editedField === "relatedToId")
                                                                        ? (() => {
                                                                            const usernameElement = option.children.props.children[1].props.children[0];
                                                                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                const username = String(usernameElement.props.children);
                                                                                return username.toLowerCase().includes(input.toLowerCase());
                                                                            }
                                                                            return false;
                                                                        })()
                                                                        : option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                                name="editedValue"
                                                                value={selectbox.editedValue}
                                                                onChange={(value, option) => {
                                                                    handleViewChange(index, 'editedValue', value, filedType, selectbox.Currency, option);
                                                                }}
                                                            >
                                                                {(selectbox.editedField === "taskOwner" || selectbox.editedField === "assignTo") &&
                                                                    users.map((option, i) => (
                                                                        <Option value={option.userId}
                                                                            label={(
                                                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                    <div className='Div_flex2'>
                                                                                        <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                                                                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                                < img src={option.profilePic} alt="profile" />
                                                                                                :
                                                                                                <span className="image_icon UserIcon">
                                                                                                    {option.firstName.slice(0, 1).toUpperCase()}
                                                                                                </span>
                                                                                            }
                                                                                            <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )}
                                                                            key={i}>
                                                                            <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                                                                                <div>
                                                                                    {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                        < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                        :
                                                                                        <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                            {option.firstName.slice(0, 1).toUpperCase()}
                                                                                        </span>
                                                                                    }</div>
                                                                                <div>
                                                                                    <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                                                                                    <p style={{ margin: 0 }}>{option.username}</p>
                                                                                </div>
                                                                            </div>
                                                                        </Option>))
                                                                }

                                                                {selectbox.editedField === "taskStatusId" && <>
                                                                    {taskStatus}
                                                                </>}
                                                                {selectbox.editedField === "priority" && <>
                                                                    {dealPriority}
                                                                </>}
                                                                {selectbox.editedField === "relatedToId" && <>{typeNames}</>}
                                                                {selectbox.editedField === "taskTypeId" && <>{allTaskType}</>}
                                                            </Select>
                                                        ) : filedType === 'Boolean' ?
                                                            <Select placeholder="Select Value"
                                                                showSearch
                                                                style={{ width: "100%" }}
                                                                optionFilterProp="children"
                                                                name="editedValue"
                                                                value={selectbox.editedValue}
                                                                onChange={(value) => {
                                                                    handleViewChange(index, 'editedValue', value, filedType, selectbox.Currency);
                                                                }}
                                                            >
                                                                {(selectbox.editedField === "resell" || selectbox.editedField === "emailOtpOut" || selectbox.editedField === "emailOptOut") && <>
                                                                    <Option value>Yes</Option>
                                                                    <Option value={false}>No</Option>
                                                                </>}
                                                            </Select>
                                                            : filedType === 'Free Text' || filedType === 'Numbers' ? (
                                                                (<Input placeholder="Enter Value" style={{ width: "100%" }}
                                                                    name="editedValue"
                                                                    value={selectbox.editedValue}
                                                                    onChange={(e) => {
                                                                        const inputValue = e.target.value
                                                                        const TotalLength = selectbox.editedField  === "street" ? 100 : 50
                                                                        if (inputValue?.toString()?.length > TotalLength) {
                                                                            message.error(`Maximum ${TotalLength} characters allowed`);
                                                                            return;
                                                                        }
                                                                        handleViewChange(index, 'editedValue', inputValue, filedType, selectbox.Currency);
                                                                    }} />
                                                                ))
                                                                : filedType === 'Date' &&
                                                                <DatePicker
                                                                    name="editedValue"
                                                                    onChange={(date) => {
                                                                        handleViewChange(index, 'editedValue', date ? date.format("YYYY-MM-DD") : null, filedType, selectbox.Currency);
                                                                    }}
                                                                    value={selectbox.editedValue ? moment(selectbox.editedValue, "YYYY-MM-DD") : null}
                                                                    format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                                />
                                                        }
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        )
                                    })}
                                </Form>
                            </BasicFormWrapper>
                        </div>
                    </AddUser> :
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "120px" }}>
                            <Spin />
                        </div>)
                }
                    {popupType.includes("Delete") &&
                        < div >
                            <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15 }}>
                                {popupType === "Bulk Delete" && <p>Are you sure you want to delete the selected tasks?</p>}
                                {popupType === "Delete" && <p>Are you sure you want to delete?</p>}
                            </div>
                        </div>
                    }</> :
                    <div className="spin" style={{ height: "250px" }}>
                        <Spin />
                    </div>}
            </Modal >
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page={pageType === "Listing" ? "DetailsError" : "Details"} type="Task" getCallBack={getRefreshtheTable} />}
            {isModalVisible && <DeleteConnectionPopup confirmPopup={isModalVisible} setConfirmPopup={HandleIsModalVisible} Respone={errorData} page={popupType === "Bulk Delete" ? "DetailsError" : "Details"} type="Task" getCallBack={getRefreshtheTable} />}
        </>
    );
};

Popup.propTypes = {
    updatePopup: PropTypes.bool.isRequired,
    setUpdatePopup: PropTypes.func.isRequired,
    taskIDs: PropTypes.array.isRequired,
    GetAll: PropTypes.func.isRequired,
    setStates: PropTypes.func.isRequired,
    popupType: PropTypes.string.isRequired,
    pageType: PropTypes.string.isRequired,
    AutomationMessage: PropTypes.string.isRequired,
    successMessage: PropTypes.func.isRequired,
};

export default Popup;